import React, { Fragment } from 'react';

export function PatreonIcon() {
    return (
        <Fragment>
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <g clip-path="url(#clip0_9_98)">
                 <path d="M0 0.5H4.219V23.5H0V0.5Z" fill="#212121" />
                 <path d="M15.384 0.5C10.617 0.5 6.73999 4.373 6.73999 9.133C6.73999 13.883 10.617 17.743 15.384 17.743C20.138 17.743 24 13.878 24 9.133C24 4.374 20.137 0.5 15.384 0.5Z" fill="#F4511E" />
               </g>
               <defs>
                 <clipPath id="clip0_9_98">
                   <rect width="24" height="24" fill="white" />
                 </clipPath>
               </defs>
             </svg>
        </Fragment>
    );
}